import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import Text from '../common/Text';
import txt from '../../utils/txt';

const useStyles = makeStyles((theme) => ({
  collection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#fff',
    background: theme.customPalette.primaryGreenG02,
    border: `1px solid ${theme.customPalette.primaryGreenG02}`,
    minHeight: 48,
    width: '100%',
    position: 'relative',
    padding: '0 24px',
  },
  collectionBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    flexGrow: 1,
  },
  collectionIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: 32,
    height: 32,
    minWidth: 32,
    objectFit: 'contain',
  },
  collectionIcon: {
    width: '100%',
  },
  collectionText: {
    padding: theme.spacing(1),
    height: 'unset',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1.14,
    fontWeight: 'normal',
    flexGrow: 1,
  },
  collectionImageContainer: {
    position: 'relative',
    bottom: 0,
    right: 0,
    height: '50px',
    maxHeight: '80px',
  },
  collectionImage: {
    height: '100%',
    objectFit: 'contain',
    width: '100%',
  },
}));

const CollectionExtensionBanner = ({ collection }) => {
  const classes = useStyles();

  return (
    <Grid xs={12}>
      <Box className={classes.collection}>
        <Box className={classes.collectionBox}>
          <Box className={classes.collectionIconWrapper}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="31"
              height="15"
              viewBox="0 0 31 15"
              fill="none">
              <path
                d="M1.71484 0.25H29.1865C29.4754 0.245538 29.7596 0.326039 30.002 0.480469C30.2441 0.63487 30.4343 0.856819 30.5488 1.11719L30.5527 1.12598C30.6646 1.35587 30.7081 1.61221 30.6777 1.86523C30.6474 2.11831 30.5443 2.35768 30.3809 2.55566L26.8369 6.84766C26.7608 6.93999 26.7608 7.07368 26.8369 7.16602L30.4502 11.543V11.5439C30.6093 11.7397 30.7099 11.975 30.7402 12.2236C30.7705 12.4724 30.7294 12.7249 30.6221 12.9521C30.5011 13.198 30.3115 13.405 30.0752 13.5488C29.8379 13.6933 29.5633 13.7683 29.2842 13.7637H1.71484C1.33272 13.7697 0.963766 13.6257 0.689453 13.3643C0.449566 13.1356 0.298942 12.8331 0.259766 12.5098L0.25 12.3701V1.65039C0.25298 1.46404 0.293229 1.27962 0.368164 1.1084C0.443131 0.937259 0.551727 0.782425 0.6875 0.652344C0.823363 0.522186 0.983885 0.419594 1.16016 0.350586C1.3365 0.281575 1.52506 0.24703 1.71484 0.25ZM1.77148 1.50195C1.6336 1.50217 1.52148 1.61401 1.52148 1.75195V12.2617C1.52148 12.3997 1.6336 12.5115 1.77148 12.5117H29.1035C29.1999 12.5116 29.2877 12.4562 29.3291 12.3691C29.3704 12.2819 29.358 12.1783 29.2969 12.1035L25.0762 6.94629L29.2344 1.91113C29.2958 1.83658 29.3087 1.73295 29.2676 1.64551C29.2263 1.55794 29.1378 1.50195 29.041 1.50195H1.77148Z"
                fill="white"
                stroke="#00828C"
                strokeWidth="0.5"
                strokeLinejoin="round"
              />
              <path
                d="M7.96831 8.1324L5.20457 4.24658H4.24658V9.76713H5.20457V5.89024L7.96831 9.76713H8.91781V4.24658H7.96831V8.1324Z"
                fill="white"
              />
              <path
                d="M11.041 9.76713H15.2876V8.85597H12.0708V7.41777H14.9778V6.49768H12.0708V5.16667H15.2876V4.24658H11.041V9.76713Z"
                fill="white"
              />
              <path
                d="M21.8576 8.20387L20.5185 4.24658H19.3995L18.0512 8.20387L16.8405 4.24658H15.7124L17.5101 9.76713H18.5282L19.959 5.66692L21.3806 9.76713H22.417L24.2056 4.24658H23.0774L21.8576 8.20387Z"
                fill="white"
              />
            </svg>
          </Box>
          {collection?.message && (
            <Text
              className={classes.collectionText}
              dangerouslySetInnerHTML={{
                __html: txt.sanifyHtml(collection.message),
              }}
            />
          )}
        </Box>
        {collection?.image && (
          <Box className={classes.collectionImageContainer}>
            <img
              className={classes.collectionImage}
              src={collection.image?.src}
              alt={collection.image?.alt || ''}
            />
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default CollectionExtensionBanner;
